import api from "../services/api";

// Service to create a new Help Topic
export const createHelpTopic = async (formData) => {
  try {
    const response = await api.post("/help-topic-management/help_topics/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      console.warn("Unexpected Response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error creating Help Topic:", error.message || error);
    return { success: false, error: error.message || "Failed to create Help Topic" };
  }
};

// Service to fetch Help Topics
export const fetchHelpTopics = async (page = 1, size = 50) => {
  try {
    const response = await api.get("/help-topic-management/help_topics/", {
      params: { page, size }
    });

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      console.warn("Unexpected Response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error fetching Help Topics:", error.message || error);
    return { success: false, error: error.message || "Failed to fetch Help Topics" };
  }
};

// Service to update a Help Topic
export const updateHelpTopic = async (topicId, payload) => {
  try {
    const response = await api.put(`/help-topic-management/help_topics/${topicId}`, payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      console.warn("Unexpected Response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error updating Help Topic:", error.message || error);
    return { success: false, error: error.message || "Failed to update Help Topic" };
  }
};

// Service to delete a Help Topic
export const deleteHelpTopic = async (topicId) => {
  try {
    const response = await api.delete(`/help-topic-management/help_topics/${topicId}`);

    if (response.status === 200 && response.data.success) {
      return { success: true, message: "Help Topic deleted successfully" };
    } else {
      console.warn("Unexpected Response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error deleting Help Topic:", error.message || error);
    return { success: false, error: error.message || "Failed to delete Help Topic" };
  }
};
